import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdateTransportActions } from "store/ducks/transports";

export function* updateTransportsRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/transports/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateTransportActions.success(data));
    notify("success", "Carga atualizada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdateTransportActions.failure(errorMessage));
  }
}
